import { showFormResponse } from '../common/json-response';

let statusWrapper;
let profileGeoRepositionScheduled = false;
let profileGeoRepositionListenersBound = false;
let profileGeoGlobalClickBound = false;
let profileGeoSuggestionMousedownBound = false;

function clearProfileGeoInputShellLayout(shell) {
  if (!shell) {
    return;
  }
  ['position', 'left', 'top', 'right', 'width', 'height', 'z-index', 'min-height', 'box-sizing', 'max-width'].forEach(
    function (p) {
      shell.style.removeProperty(p);
    }
  );
  shell.classList.remove('profile-geo--input-fixed');
  const anchor = shell.closest('.profile-geo-input-anchor');
  if (anchor) {
    anchor.style.removeProperty('min-height');
  }
}

/**
 * Выносит оболочку поля в fixed к якорю (как выпадашка), чтобы не прокручивать карточку.
 */
function positionProfileGeoInputShell(typeahead) {
  if (!typeahead) {
    return;
  }
  if (typeahead.classList.contains('profile-geo-typeahead--inline')) {
    return;
  }
  const panel = typeahead.closest('.profile-geo-panel');
  if (!panel || panel.style.display !== 'flex') {
    return;
  }
  const anchor = typeahead.querySelector('.profile-geo-input-anchor');
  const shell = typeahead.querySelector('.profile-geo-input-shell');
  if (!anchor || !shell) {
    return;
  }
  const r = anchor.getBoundingClientRect();
  if (r.width < 2) {
    return;
  }
  const margin = 8;
  const vw = window.innerWidth;
  const width = Math.min(r.width, vw - 2 * margin);
  const left = Math.min(Math.max(margin, r.left), vw - margin - width);
  const top = r.top;

  shell.style.position = 'fixed';
  shell.style.left = `${left}px`;
  shell.style.top = `${top}px`;
  shell.style.width = `${width}px`;
  shell.style.zIndex = '20100';
  shell.classList.add('profile-geo--input-fixed');

  requestAnimationFrame(function () {
    const h = shell.getBoundingClientRect().height;
    if (h > 0) {
      anchor.style.minHeight = `${Math.ceil(h)}px`;
    }
  });
}

function clearProfileGeoDropdownLayout(suggestionsBlock) {
  if (!suggestionsBlock || !suggestionsBlock.classList.contains('profile-geo-suggestions')) {
    return;
  }
  ['position', 'left', 'top', 'right', 'width', 'z-index', 'max-height', 'overflow-y'].forEach(
    function (p) {
      suggestionsBlock.style.removeProperty(p);
    }
  );
  suggestionsBlock.classList.remove('profile-geo--fixed');
}

function positionProfileGeoDropdown(suggestionsBlock) {
  if (!suggestionsBlock || !suggestionsBlock.classList.contains('active')) {
    return;
  }
  const typeahead = suggestionsBlock.closest('.profile-geo-typeahead');
  if (!typeahead) {
    return;
  }
  const anchor = typeahead.querySelector('.profile-geo-input-shell');
  if (!anchor) {
    return;
  }
  const r = anchor.getBoundingClientRect();
  const gap = 6;
  const margin = 8;
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const width = Math.min(r.width, vw - 2 * margin);
  const left = Math.min(Math.max(margin, r.left), vw - margin - width);
  const top = r.bottom + gap;
  const maxH = Math.max(100, Math.min(320, vh - top - margin));

  suggestionsBlock.style.position = 'fixed';
  suggestionsBlock.style.left = `${left}px`;
  suggestionsBlock.style.top = `${top}px`;
  suggestionsBlock.style.width = `${width}px`;
  suggestionsBlock.style.zIndex = '20050';
  suggestionsBlock.style.maxHeight = `${maxH}px`;
  suggestionsBlock.style.overflowY = 'auto';
  suggestionsBlock.classList.add('profile-geo--fixed');
}

function scheduleProfileGeoReposition() {
  if (profileGeoRepositionScheduled) {
    return;
  }
  profileGeoRepositionScheduled = true;
  requestAnimationFrame(function () {
    profileGeoRepositionScheduled = false;
    document.querySelectorAll('.profile-geo-panel').forEach(function (panel) {
      if (panel.style.display === 'flex') {
        const ta = panel.querySelector('.profile-geo-typeahead');
        if (ta) {
          positionProfileGeoInputShell(ta);
        }
      }
    });
    document.querySelectorAll('.suggestions-wrapper.profile-geo-suggestions.active').forEach(
      function (sw) {
        positionProfileGeoDropdown(sw);
      }
    );
  });
}

function getGeoId(prefix, name) {
  return (prefix || '') + name;
}

/**
 * Крестик очищает только видимый input; без этого скрытые region/settlement
 * остаются с прежними значениями и уходят на сервер при «Сохранить».
 *
 * @param {HTMLInputElement} searchInput — search_region или search_settlement
 */
function clearProfileGeoHiddenForSearchInput(searchInput) {
  const root = searchInput.closest('[data-dadata-geo-root]');
  const prefix = root ? (root.getAttribute('data-geo-prefix') || '') : '';
  const id = (s) => getGeoId(prefix, s);
  const inputId = searchInput.id || '';
  const inputName = searchInput.getAttribute('name') || '';

  const isRegion =
    inputId === id('search_region') ||
    inputName === id('search_region') ||
    (prefix === '' && (inputId === 'search_region' || inputName === 'search_region'));
  const isSettlement =
    inputId === id('search_settlement') ||
    inputName === id('search_settlement') ||
    (prefix === '' && (inputId === 'search_settlement' || inputName === 'search_settlement'));

  if (isRegion) {
    const regionHidden = document.getElementById(id('region'));
    const regionForFilter = document.getElementById(id('region_for_filter'));
    if (regionHidden) {
      regionHidden.value = '';
    }
    if (regionForFilter) {
      regionForFilter.value = '';
    }
    const searchSettlement = document.getElementById(id('search_settlement'));
    const settlementHidden = document.getElementById(id('settlement'));
    if (searchSettlement) {
      searchSettlement.value = '';
    }
    if (settlementHidden) {
      settlementHidden.value = '';
    }
    const settlementGroup = document.getElementById(id('profile-settlement-group'));
    if (settlementGroup) {
      settlementGroup.style.display = 'none';
    }
    if (searchSettlement) {
      searchSettlement.disabled = true;
    }
  } else if (isSettlement) {
    const settlementHidden = document.getElementById(id('settlement'));
    if (settlementHidden) {
      settlementHidden.value = '';
    }
  }
}

function initProfileGeoClearButtons() {
  document.querySelectorAll('.js-profile-geo-search-clear').forEach(function (btn) {
    if (btn.dataset.geoClearBound) {
      return;
    }
    btn.dataset.geoClearBound = '1';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const id = btn.getAttribute('data-clear-target');
      const input = id ? document.getElementById(id) : null;
      if (!input) {
        return;
      }
      input.value = '';
      clearProfileGeoHiddenForSearchInput(input);
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  });
}

/**
 * @param {HTMLElement|Document|Document['documentElement']} rootEl
 */
function findSuggestionsBlockFromInput(addressInput) {
  const typeahead = addressInput.closest('.profile-geo-typeahead');
  if (typeahead) {
    return typeahead.querySelector('.suggestions-wrapper');
  }
  const resultSelector = addressInput.getAttribute('data-result-block-selector');
  const scope = addressInput.closest('[data-dadata-geo-root]') || document;
  if (resultSelector) {
    return scope.querySelector(resultSelector);
  }
  return null;
}

/**
 * Скрыть выпадашку подсказок при уходе фокуса (иначе панель оставалась на экране).
 */
function closeSuggestionsForInput(addressInput) {
  const suggestionsBlock = findSuggestionsBlockFromInput(addressInput);
  if (!suggestionsBlock) {
    return;
  }
  suggestionsBlock.innerHTML = '';
  suggestionsBlock.classList.remove('active', 'profile-geo--fixed');
  if (suggestionsBlock.classList.contains('profile-geo-suggestions')) {
    clearProfileGeoDropdownLayout(suggestionsBlock);
  }
}

/**
 * @param {HTMLElement|Document|Document['documentElement']} rootEl
 */
function initAddressSuggestionsForRoot(rootEl) {
  const isDocumentRoot = rootEl === document || rootEl === document.documentElement;
  const prefix = isDocumentRoot ? '' : (rootEl.getAttribute('data-geo-prefix') || '');
  const id = (s) => getGeoId(prefix, s);
  const inputRegion = document.getElementById(id('search_region'));
  const inputSettlement = document.getElementById(id('search_settlement'));
  if (!inputRegion || !inputSettlement) {
    return;
  }

  initProfileGeoRepositionListeners();
  if (!statusWrapper) {
    statusWrapper = document.querySelector('.action-status-messages');
  }

  const getSuggestAddresHandler = function (e) {
    const addressInput = e.target;
    if (!addressInput.getAttribute('data-address-url')) {
      return;
    }
    const fieldName = addressInput.getAttribute('name') || '';
    const suggestionsBlock = findSuggestionsBlockFromInput(addressInput);
    if (!suggestionsBlock) {
      return;
    }

    const q = (addressInput.value || '').trim();
    if (q.length === 0) {
      suggestionsBlock.innerHTML = '';
      suggestionsBlock.classList.remove('active', 'profile-geo--fixed');
      clearProfileGeoDropdownLayout(suggestionsBlock);
      return;
    }

    if (fieldName === id('search_settlement') || (prefix === '' && fieldName === 'search_settlement')) {
      const regionForFilter = document.getElementById(id('region_for_filter'));
      const rf = (regionForFilter && regionForFilter.value) ? String(regionForFilter.value).trim() : '';
      if (rf.length === 0) {
        suggestionsBlock.innerHTML = '';
        suggestionsBlock.classList.remove('active', 'profile-geo--fixed');
        clearProfileGeoDropdownLayout(suggestionsBlock);
        return;
      }
    }

    let url = addressInput.getAttribute('data-address-url');
    if (fieldName === id('search_region') || (prefix === '' && fieldName === 'search_region')) {
      url = url + '?region=' + encodeURIComponent((inputRegion.value || '').trim());
    } else if (fieldName === id('search_settlement') || (prefix === '' && fieldName === 'search_settlement')) {
      const regionForFilter = document.getElementById(id('region_for_filter'));
      const rfv = regionForFilter && regionForFilter.value ? String(regionForFilter.value).trim() : '';
      url = url + '?region=' + encodeURIComponent(rfv) + '&settlement=' + encodeURIComponent((inputSettlement.value || '').trim());
    }

    $.ajax({
      type: "GET",
      url: url,
      dataType: 'json',
      success: function (data) {
        if (data.messages) {
          showFormResponse(data);
        } else if (data.html) {
          suggestionsBlock.innerHTML = '';
          suggestionsBlock.insertAdjacentHTML('beforeEnd', data.html);
          suggestionsBlock.classList.add('active');

          if (inputSettlement.disabled) {
            inputSettlement.disabled = false;
          }

          initSuggestions(suggestionsBlock, prefix);
          requestAnimationFrame(function () {
            const typeahead = suggestionsBlock.closest('.profile-geo-typeahead');
            if (typeahead) {
              positionProfileGeoInputShell(typeahead);
            }
            if (suggestionsBlock.classList.contains('profile-geo-suggestions')) {
              positionProfileGeoDropdown(suggestionsBlock);
            }
          });
        } else {
          suggestionsBlock.innerHTML = '';
          suggestionsBlock.classList.remove('active', 'profile-geo--fixed');
          clearProfileGeoDropdownLayout(suggestionsBlock);
        }
      },
      error: function (data) {
        if (data.messages) {
          showFormResponse(data);
        } else {
          const message = 'Возникла ошибка. Обратитесь пожалуйста в тех. поддержку';
          if (statusWrapper) {
            const statusMsg = document.createElement('div');
            statusMsg.classList.add(['alert']);
            statusMsg.classList.add(['alert_error']);
            statusMsg.innerHTML = message;
            statusWrapper.appendChild(statusMsg);
          }
        }
      },
    });
  };

  initProfileGeoClearButtons();
  inputRegion.addEventListener('input', getSuggestAddresHandler);
  inputSettlement.addEventListener('input', getSuggestAddresHandler);
  const scopeForInitialSuggest = isDocumentRoot ? document : rootEl;
  scopeForInitialSuggest
    .querySelectorAll('.suggestions-wrapper.profile-geo-suggestions')
    .forEach(function (sw) {
      initSuggestions(sw, prefix);
    });

  const onGeoSearchBlur = function (e) {
    const t = e.target;
    setTimeout(function () {
      closeSuggestionsForInput(t);
    }, 200);
  };
  inputRegion.addEventListener('blur', onGeoSearchBlur);
  inputSettlement.addEventListener('blur', onGeoSearchBlur);

  inputRegion.addEventListener('focus', scheduleProfileGeoReposition);
  inputSettlement.addEventListener('focus', scheduleProfileGeoReposition);
}

function initProfileGeoRepositionListeners() {
  if (profileGeoRepositionListenersBound) {
    return;
  }
  profileGeoRepositionListenersBound = true;
  window.addEventListener('scroll', scheduleProfileGeoReposition, true);
  window.addEventListener('resize', scheduleProfileGeoReposition);
}

function bindProfileGeoGlobalClick() {
  if (profileGeoGlobalClickBound) {
    return;
  }
  profileGeoGlobalClickBound = true;
  document.addEventListener('click', (e) => {
    if (e.target.closest('.profile-geo-typeahead')) {
      return;
    }
    if (e.target.closest('.suggestions-wrapper')) {
      return;
    }
    document.querySelectorAll('.suggestions-wrapper').forEach(function (suggestionsWrapper) {
      if (suggestionsWrapper.classList.contains('profile-geo-suggestions')) {
        clearProfileGeoDropdownLayout(suggestionsWrapper);
      }
      suggestionsWrapper.classList.remove('active');
    });
  });
}

function initAddressSuggestions() {
  if (!profileGeoSuggestionMousedownBound) {
    profileGeoSuggestionMousedownBound = true;
    document.addEventListener(
      'mousedown',
      function (e) {
        if (e.target && e.target.closest && e.target.closest('.suggestions-suggestion')) {
          e.preventDefault();
        }
      },
      true
    );
  }

  const roots = document.querySelectorAll('[data-dadata-geo-root]');
  if (roots.length) {
    roots.forEach(function (r) {
      initAddressSuggestionsForRoot(r);
    });
    bindProfileGeoGlobalClick();
  } else if (document.getElementById('search_region') && document.getElementById('search_settlement')) {
    initAddressSuggestionsForRoot(document.documentElement);
    bindProfileGeoGlobalClick();
  }
}

/**
 * @param {string} prefix p_, t_ или ''
 */
function initSuggestions(suggestionsBlock, prefix) {
  if (typeof prefix === 'undefined' || prefix === null) {
    prefix = '';
  }
  if (!suggestionsBlock) {
    return;
  }

  const isRegionList = suggestionsBlock.classList.contains('region');
  const suggestions = suggestionsBlock.querySelectorAll('.suggestions-suggestion');

  suggestions?.forEach(function (item) {
    item.addEventListener('click', function (e) {
      const valueElement = item.querySelector('.suggestions-value');
      if (!valueElement) {
        return;
      }
      const value = valueElement.getAttribute('data-value') || '';
      const suggestionsInputParent = item.closest('.suggestions-input-parent');
      if (!suggestionsInputParent) {
        return;
      }
      const showUserSuggestion = suggestionsInputParent.querySelector('.selected-regions-text');
      const suggestionSearchInput = suggestionsInputParent.querySelector('.suggestions-search-input');
      const id = (s) => getGeoId(prefix, s);
      const regionHidden = document.getElementById(id('region'));
      const settlementHidden = document.getElementById(id('settlement'));
      if (isRegionList) {
        if (regionHidden) {
          regionHidden.value = value;
        }
      } else if (settlementHidden) {
        settlementHidden.value = value;
      }
      if (showUserSuggestion) {
        showUserSuggestion.textContent = value;
      }
      if (suggestionSearchInput) {
        suggestionSearchInput.value = value;
      }

      const regionFias = valueElement.getAttribute('data-region');

      if (regionFias) {
        const regionForFilterInput = document.getElementById(id('region_for_filter'));
        if (regionForFilterInput) {
          regionForFilterInput.value = regionFias;
        }
        const inputSettlement = document.getElementById(id('search_settlement'));
        if (inputSettlement) {
          inputSettlement.value = '';
        }
        if (settlementHidden) {
          settlementHidden.value = '';
        }
        const settlementGroup = document.getElementById(id('profile-settlement-group'));
        if (settlementGroup) {
          settlementGroup.style.display = 'block';
        }
        if (inputSettlement) {
          inputSettlement.disabled = false;
        }
      }

      const suggestionsWrapper = suggestionsInputParent.querySelector('.suggestions-wrapper');
      if (suggestionsWrapper) {
        suggestionsWrapper.classList.remove('active', 'profile-geo--fixed');
        if (suggestionsWrapper.classList.contains('profile-geo-suggestions')) {
          clearProfileGeoDropdownLayout(suggestionsWrapper);
        }
        suggestionsWrapper.innerHTML = '';
      }
      const taSelect = suggestionsInputParent.querySelector('.profile-geo-typeahead');
      if (taSelect) {
        const shellSelect = taSelect.querySelector('.profile-geo-input-shell');
        clearProfileGeoInputShellLayout(shellSelect);
      }
      const geoPanel = suggestionsInputParent.querySelector('.profile-geo-panel');
      if (geoPanel) {
        geoPanel.style.display = 'none';
      } else {
        const searchToggle = suggestionsInputParent.querySelector('.search-toggle');
        if (searchToggle) {
          const clickEvent = new Event('click');
          searchToggle.dispatchEvent(clickEvent);
        }
      }
    });
  });
}

export { initAddressSuggestions }
